<template>
  <div class="dashboard dashboard-lab">
    <b-container fluid class="dashboard-lab-container">
      <!-- Panel de bienvenida -->
      <section class="welcome-panel">
        <div class="welcome-copy">
          <h2>Bienvenido a Arrendamiento</h2>
        </div>
      </section>

      <!-- Barra de herramientas -->
      <section class="outside-toolbar">
        <button class="btn btn-info btn-sm">
          Crear etiqueta
        </button>
        <small>Etiquetas: 4/50</small>
      </section>

      <!-- Malla de etiquetas -->
      <section ref="canvas" class="tags-canvas">
        <!-- Etiqueta 1: Comportamiento P&L -->
        <article 
          class="mini-tag" 
          style="left: 20px; top: 20px; width: 340px; height: 230px; background-color: #f5faff; z-index: 1;"
        >
          <header class="mini-tag-header">
            <strong>Comportamiento P&L</strong>
            <div class="mini-tag-actions">
              <button class="mini-edit">⋮</button>
              <button class="mini-delete">×</button>
            </div>
          </header>
          <div class="mini-tag-body">
            <div class="pl-summary-card">
              <strong>Comparación anual</strong>
              <div class="pl-report-panel">
                <div class="pl-chart">
                  <div class="pl-chart-plot">
                    <div class="pl-chart-categories">
                      <!-- Gasto Amortización -->
                      <div class="pl-category">
                        <div class="pl-bars">
                          <div class="pl-bar-group">
                            <span class="pl-bar-value">$1,234,567</span>
                            <div class="pl-bar-track">
                              <span class="pl-bar-fill" style="height: 85%; background: hsl(2, 54%, 54%);"></span>
                            </div>
                          </div>
                          <div class="pl-bar-group">
                            <span class="pl-bar-value">$987,654</span>
                            <div class="pl-bar-track">
                              <span class="pl-bar-fill" style="height: 65%; background: hsl(215, 54%, 55%);"></span>
                            </div>
                          </div>
                        </div>
                        <div class="pl-category-label">Gasto Amortización</div>
                      </div>
                      <!-- Gasto Intereses -->
                      <div class="pl-category">
                        <div class="pl-bars">
                          <div class="pl-bar-group">
                            <span class="pl-bar-value">$876,543</span>
                            <div class="pl-bar-track">
                              <span class="pl-bar-fill" style="height: 60%; background: hsl(2, 54%, 54%);"></span>
                            </div>
                          </div>
                          <div class="pl-bar-group">
                            <span class="pl-bar-value">$654,321</span>
                            <div class="pl-bar-track">
                              <span class="pl-bar-fill" style="height: 45%; background: hsl(215, 54%, 55%);"></span>
                            </div>
                          </div>
                        </div>
                        <div class="pl-category-label">Gasto Intereses</div>
                      </div>
                    </div>
                  </div>
                  <div class="pl-chart-legend">
                    <span class="pl-legend-item">
                      <i class="pl-legend-dot" style="background: hsl(2, 54%, 54%);"></i>
                      2024
                    </span>
                    <span class="pl-legend-item">
                      <i class="pl-legend-dot" style="background: hsl(215, 54%, 55%);"></i>
                      2025
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>

        <!-- Etiqueta 2: NOTA A LOS ESTADOS FINANCIEROS -->
        <article 
          class="mini-tag" 
          style="left: 380px; top: 20px; width: 460px; height: 280px; background-color: #f5faff; z-index: 2;"
        >
          <header class="mini-tag-header">
            <strong>NOTA A LOS ESTADOS FINANCIEROS</strong>
          </header>
          <div class="mini-tag-body">
            <div class="pl-note-card">
              <div class="pl-note-columns">
                <section class="pl-note-section">
                  <h6>ACTIVO POR DERECHO DE USO</h6>
                  <div class="pl-note-row"><span>Saldo inicial</span><strong>$1,234,567</strong></div>
                  <div class="pl-note-row"><span>+ Nuevos contratos</span><strong>$234,567</strong></div>
                  <div class="pl-note-row"><span>+ Ajustes al pasivo</span><strong>$12,345</strong></div>
                  <div class="pl-note-row"><span>- Bajas</span><strong>$45,678</strong></div>
                  <div class="pl-note-row total"><span>Saldo final</span><strong>$1,435,801</strong></div>
                </section>
                <section class="pl-note-section">
                  <h6>PASIVO POR ARRENDAMIENTO</h6>
                  <div class="pl-note-row"><span>Saldo inicial</span><strong>$1,100,000</strong></div>
                  <div class="pl-note-row"><span>+ Nuevos contratos</span><strong>$200,000</strong></div>
                  <div class="pl-note-row"><span>+ Ajustes al pasivo</span><strong>$10,000</strong></div>
                  <div class="pl-note-row"><span>+ Intereses causados</span><strong>$50,000</strong></div>
                  <div class="pl-note-row"><span>- Pagos de intereses</span><strong>$40,000</strong></div>
                  <div class="pl-note-row"><span>- Pagos de capital</span><strong>$30,000</strong></div>
                  <div class="pl-note-row"><span>- Bajas</span><strong>$45,678</strong></div>
                  <div class="pl-note-row total"><span>Saldo final</span><strong>$1,244,322</strong></div>
                </section>
              </div>
            </div>
          </div>
        </article>

        <!-- Etiqueta 3: Gráfico de Pastel -->
        <article 
          class="mini-tag" 
          style="left: 20px; top: 270px; width: 240px; height: 175px; background-color: #f0f8ff; z-index: 3;"
        >
          <header class="mini-tag-header">
            <strong>Distribución por Tipo</strong>
            <div class="mini-tag-actions">
              <button class="mini-edit">⋮</button>
              <button class="mini-delete">×</button>
            </div>
          </header>
          <div class="mini-tag-body">
            <div class="chart-panel">
              <div class="mini-pie" style="width: 80px; height: 80px; border-radius: 50%; background: conic-gradient(#4A90D9 0% 45%, #50C878 45% 70%, #FFB74D 70% 85%, #EF5350 85% 100%); margin: 0 auto;"></div>
              <div class="mini-series-legend">
                <span class="series-chip"><i class="series-dot" style="background: #4A90D9;"></i> Tipo A 45%</span>
                <span class="series-chip"><i class="series-dot" style="background: #50C878;"></i> Tipo B 25%</span>
                <span class="series-chip"><i class="series-dot" style="background: #FFB74D;"></i> Tipo C 15%</span>
              </div>
            </div>
          </div>
        </article>

        <!-- Etiqueta 4: Gráfico de Barras -->
        <article 
          class="mini-tag" 
          style="left: 280px; top: 270px; width: 260px; height: 175px; background-color: #faf5ff; z-index: 4;"
        >
          <header class="mini-tag-header">
            <strong>Ventas por Mes</strong>
            <div class="mini-tag-actions">
              <button class="mini-edit">⋮</button>
              <button class="mini-delete">×</button>
            </div>
          </header>
          <div class="mini-tag-body">
            <div class="chart-panel bars-panel">
              <div class="mini-bars">
                <div class="mini-bar-group">
                  <div class="mini-bar-pair">
                    <div class="mini-bar-item">
                      <div class="mini-bar-top-metrics">
                        <small class="mini-bar-value">$450K</small>
                      </div>
                      <span class="mini-bar-fill" style="height: 80%; background: #4A90D9;"></span>
                    </div>
                    <div class="mini-bar-item">
                      <div class="mini-bar-top-metrics">
                        <small class="mini-bar-value">$320K</small>
                      </div>
                      <span class="mini-bar-fill" style="height: 57%; background: #50C878;"></span>
                    </div>
                    <div class="mini-bar-item">
                      <div class="mini-bar-top-metrics">
                        <small class="mini-bar-value">$280K</small>
                      </div>
                      <span class="mini-bar-fill" style="height: 50%; background: #FFB74D;"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
      </section>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "DashboardVisualOnly",
  // Sin lógica, solo la vista
};
</script>

<style scoped>
/* Estilos mínimos para que se vea la malla */
.dashboard-lab-container {
  padding: 20px;
  background: #f8f9fa;
  min-height: 100vh;
}

.welcome-panel {
  background: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.welcome-copy h2 {
  margin: 0;
  color: #2c3e50;
}

.outside-toolbar {
  display: flex;
  gap: 15px;
  align-items: center;
  margin-bottom: 20px;
  padding: 10px 0;
}

.tags-canvas {
  position: relative;
  min-height: 600px;
  background: white;
  border-radius: 8px;
  padding: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.mini-tag {
  position: absolute;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.12);
  border: 1px solid rgba(0,0,0,0.06);
  transition: box-shadow 0.2s;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.mini-tag:hover {
  box-shadow: 0 4px 16px rgba(0,0,0,0.18);
}

.mini-tag-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.mini-tag-header strong {
  font-size: 13px;
  color: #2c3e50;
}

.mini-tag-actions {
  display: flex;
  gap: 4px;
}

.mini-edit, .mini-delete {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0 4px;
  font-size: 16px;
  color: #6c757d;
  border-radius: 4px;
}

.mini-edit:hover, .mini-delete:hover {
  background: rgba(0,0,0,0.08);
}

.mini-tag-body {
  flex: 1;
  overflow: auto;
  font-size: 12px;
}

/* Estilos para P&L */
.pl-summary-card {
  padding: 8px;
}

.pl-report-panel {
  margin-top: 8px;
}

.pl-chart {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.pl-chart-plot {
  position: relative;
}

.pl-chart-categories {
  display: flex;
  gap: 20px;
  justify-content: center;
}

.pl-category {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  flex: 1;
}

.pl-bars {
  display: flex;
  gap: 8px;
  height: 80px;
  align-items: flex-end;
}

.pl-bar-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.pl-bar-track {
  width: 24px;
  height: 70px;
  background: rgba(0,0,0,0.05);
  border-radius: 4px;
  position: relative;
  overflow: hidden;
}

.pl-bar-fill {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  border-radius: 4px 4px 0 0;
  transition: height 0.3s;
}

.pl-bar-value {
  font-size: 9px;
  color: #6c757d;
}

.pl-category-label {
  font-size: 10px;
  color: #495057;
  text-align: center;
}

.pl-chart-legend {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 6px;
}

.pl-legend-item {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  color: #495057;
}

.pl-legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}

/* Estilos para Nota Financiera */
.pl-note-card {
  padding: 4px;
}

.pl-note-columns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.pl-note-section {
  font-size: 10px;
}

.pl-note-section h6 {
  margin: 0 0 4px 0;
  font-size: 10px;
  font-weight: bold;
  color: #2c3e50;
}

.pl-note-row {
  display: flex;
  justify-content: space-between;
  padding: 2px 0;
  border-bottom: 1px solid rgba(0,0,0,0.04);
}

.pl-note-row.total {
  border-top: 2px solid #2c3e50;
  border-bottom: none;
  font-weight: bold;
  margin-top: 4px;
  padding-top: 4px;
}

/* Estilos para gráficos */
.chart-panel {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
}

.mini-pie {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

.mini-series-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 8px;
  justify-content: center;
}

.series-chip {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 10px;
  color: #495057;
}

.series-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
}

/* Barras */
.mini-bars {
  width: 100%;
}

.mini-bar-group {
  width: 100%;
}

.mini-bar-pair {
  display: flex;
  gap: 12px;
  justify-content: center;
  height: 90px;
  align-items: flex-end;
}

.mini-bar-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  flex: 1;
}

.mini-bar-top-metrics {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mini-bar-value {
  font-size: 8px;
  color: #6c757d;
}

.mini-bar-fill {
  width: 28px;
  border-radius: 4px 4px 0 0;
  min-height: 8px;
}

.mini-bar-label {
  font-size: 9px;
  color: #6c757d;
  text-align: center;
}

/* Responsive */
@media (max-width: 768px) {
  .mini-tag {
    position: relative !important;
    margin-bottom: 12px;
    width: 100% !important;
    height: auto !important;
    min-height: 150px;
    left: 0 !important;
    top: 0 !important;
  }
  
  .tags-canvas {
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-height: auto;
  }
  
  .pl-note-columns {
    grid-template-columns: 1fr;
  }
}
</style>